<ng-template #content let-modal>
  <div class="modal-content" style="padding: 25px;width: 541px;border-radius: 0px;">
    <div class="modal-header row">
      <span class="modal-title" id="modal-basic-title">{{'' | i18n: 'confirmdeliverydetails'}}</span>
      <div class = "col-lg-1">
        <button type="button"  (click)="modal.close('Cancelled')">
          <i aria-hidden="true" data-dismiss="modal" aria-label="Close" class="fa fa-times"></i>
        </button>
      </div>

    </div>
    <div class="modal-body">
      <div class = "mt-2" style="display: flex;">
        <div class = "tile">
          {{'' | i18n: 'delivery-mileage'}}:<br>
          <input type="text" class = "mb-4" [(ngModel)]="warranty.contract.deliveryMileage" [disabled]="warranty.contract.acceptYes || warranty.contract.acceptNo"/> <br>
          {{'' | i18n: 'correct-mileage'}} <br>
          <div class = "yes-no-container">
            <span class="accept-no">{{'' | i18n: 'no'}}</span>
            <label class="switch">
              <input type="checkbox" id="accept_no" [(ngModel)]="warranty.contract.acceptNo">
              <span class="slider round"></span>
            </label>
            <span class="accept-yes" style="padding-left: 20px;">{{'' | i18n: 'yes'}}</span>
          </div>

          </div>
        <div class = "tile" style="margin-left: 22px;">
          {{'' | i18n: 'delivery-date'}}:<br>
          <input type="text"  class = "mb-4"  [(ngModel)]="warranty.contract.deliveryDate" [disabled]="warranty.contract.acceptYes || warranty.contract.acceptNo"/> <br>
          {{'' | i18n: 'correctdate'}} <br>

          <div class = "yes-no-container">
            <span class="accept-no">{{'' | i18n: 'no'}}</span>
            <label class="switch">
              <input type="checkbox" id="accept-yes" [(ngModel)]="warranty.contract.acceptYes">
              <span class="slider round"></span>
            </label>
            <span class="accept-yes" style="padding-left: 20px;">{{'' | i18n: 'yes'}}</span>
          </div>
        </div>
      </div>
    </div>


    <div class="modal-footer">
      <button type="button" class="btn btn-back" (click)="modal.close('Cancelled')">{{'' | i18n: 'back'}}</button>
      <button type="button" class="btn btn-default" (click)="submitWarranty()" [disabled]="!warranty.contract.acceptYes || !warranty.contract.acceptNo">{{'' | i18n: 'ok'}}</button>
  </div>
  </div>
</ng-template>
